<template>
<div uk-sticky="show-on-up: true; animation: uk-animation-slide-top; sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky; bottom: #transparent-sticky-navbar" uk-margin>
  <nav class="uk-navbar-container" uk-navbar style="position: relative; z-index: 980;">
    <div class="nav-mobile uk-position-center-left">
      <a class="uk-hidden@m" uk-toggle="target: #offcanvas-nav" href="" uk-icon="icon: menu; ratio: 1.2" :aria-label="$t('nav.menu')"></a>
    </div>
    <div class="uk-navbar-center">
      <div class="uk-navbar-center-left">
        <ul class="uk-navbar-nav uk-visible@m">
          <li>
              <router-link :to="`/${$i18n.locale}/`">Home</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/uber-mich`">{{ $t('nav.uebermich')}}</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/vorgehen`">{{ $t('nav.vorgehen')}}</router-link>
          </li>
        </ul>
      </div>
      <router-link :to="`/${$i18n.locale}/`" class="uk-navbar-item uk-logo"><img :src="logo[$i18n.locale]" width="260" :alt="$t('base.title')"></router-link>
      <!--<a href="/" class="uk-navbar-item uk-logo uk-hidden@s"><img src="../assets/nike6.svg" width="200px"></a>-->
      <div class="uk-navbar-center-right">
        <ul class="uk-navbar-nav uk-visible@m">
        <li>
          <router-link :to="`/${$i18n.locale}/problembereiche`">{{ $t('nav.problembereiche')}}</router-link>
        </li>
        <li>
          <router-link :to="`/${$i18n.locale}/therapiekosten`">{{ $t('nav.kosten')}}</router-link>
        </li>
        <li>
          <router-link :to="`/${$i18n.locale}/kontakt`">{{ $t('nav.kontakt')}}</router-link>
        </li>
      </ul>
    </div>
    </div>
  </nav>
  <div id="offcanvas-nav" uk-offcanvas="overlay: true">
    <div class="uk-offcanvas-bar">
        <ul class="uk-nav uk-nav-default">
          <li>
            <router-link :to="`/${$i18n.locale}/`" class="uk-offcanvas-close">Home</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/uber-mich`" class="uk-offcanvas-close">{{ $t('nav.uebermich')}}</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/vorgehen`" class="uk-offcanvas-close">{{ $t('nav.vorgehen')}}</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/problembereiche`" class="uk-offcanvas-close">{{ $t('nav.problembereiche')}}</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/therapiekosten`" class="uk-offcanvas-close">{{ $t('nav.kosten')}}</router-link>
          </li>
          <li>
            <router-link :to="`/${$i18n.locale}/kontakt`" class="uk-offcanvas-close">{{ $t('nav.kontakt')}}</router-link>
          </li>
        </ul>
        <LocaleChanger class="uk-offcanvas-close"></LocaleChanger>
    </div>
</div>
</div>
</template>

<script>
import LocaleChanger from "@/components/LocaleChanger"
export default {
  name: 'App',
  components: {
    LocaleChanger
  },
  data() {
    return {
      logo: {
        en: require('../assets/nike_logo_en.svg'),
        de: require('../assets/nike_logo_de.svg')
      }
    }
  }
}
</script>
